<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <v-card min-height="600">
          <div class="card">
            <v-alert v-if="meetingState === 'beforeStart'" type="info" width="100%" dense>
              Spotkanie rozpocznie się
              <strong>{{ meetingStartDate | meetingDate }}</strong>
              .
            </v-alert>
            <v-alert v-else-if="meetingState === 'now'" type="info" width="100%" dense>
              Spotkanie właśnie rozpoczeło się <strong>{{ meetingStartDate | meetingDate }}</strong> i będzie
              <strong>trwać</strong> do <strong>{{ meetingEndDate | date }}</strong
              >.
            </v-alert>
            <v-alert v-else-if="meetingState === 'finished'" type="warning" width="100%" dense>
              Spotkanie już się <strong>odbyło</strong> {{ meetingStartDate | meetingDate }}.
            </v-alert>
            <v-alert v-if="alreadyInAMeeting" type="error" width="100%" dense>
              <div>Użytkownik zalogowany na Twoim koncie jest już na spotkaniu.</div>
              <div>Upewnij się czy ktoś nie posiada Twojego loginu i hasła. Ewentualnie spróbuj za chwilę.</div>
            </v-alert>
            <v-scroll-y-transition>
              <v-row v-if="meetingState === 'now'" justify="center">
                <MeetingViewerModal :element="element" @alreadyInAMeeting="alreadyInAMeeting = true" />
              </v-row>
            </v-scroll-y-transition>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <ElementExecutionBack />
  </v-container>
</template>

<script>
import ElementExecutionBack from '@/components/course/navigation/ElementExecutionBack.vue';
import * as moment from 'moment';
import MeetingViewerModal from '@/components/course/element/MeetingViewerModal.vue';

export default {
  components: {
    ElementExecutionBack,
    MeetingViewerModal
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    courseId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      alreadyInAMeeting: false
    };
  },
  computed: {
    execution() {
      return JSON.parse(this.element.execution);
    },
    meetingStartDate() {
      return moment(this.execution.dateFrom);
    },
    meetingEndDate() {
      return moment(this.execution.dateTo);
    },
    meetingState() {
      const now = moment();
      return this.meetingStartDate.isAfter(now)
        ? 'beforeStart'
        : this.meetingStartDate.isBefore(now) && this.meetingEndDate.isBefore(now)
        ? 'finished'
        : 'now';
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 16px;
}
</style>
